import React from 'react';
import { Route } from 'react-router-dom'
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { VisitViewControllerDelegate, VisitViewController } from "../../Screen/Visit/VisitViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController, NavOptions } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { VisitViewModel } from '../../Screen/Visit/VisitViewModel';
import { TableGenericFilter } from '../TableGeneric/TableGenericInteractor';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { PermissionWrapper } from '../../Funcoes/PermissionWrapper';

export class VisitCoordinator implements IndexCoordinatorDelegate, VisitViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTableVisit(),
            this.routeFormVisit(),
            this.routeTableVisitShape(),
            this.routeFormVisitShape(),
            this.routeTableVisitAdminProcess(),
            this.routeFormVisitAdminProcess(),
            this.routeTableVisitProperty(),
            this.routeFormVisitProperty(),
            this.routeTableVisitPropertyBuilding(),
            this.routeFormVisitPropertyBuilding()
        ]
    }

    private routeTableVisit(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepvisita")
        return (<ProtectedRoute path="/:base/ponto/:id/tipo/:tipo/tipo-vetor/:vetor/visita/" exact={true} component={(props: any) => {
            var idFk = props.match.params.id
            var filter = new TableGenericFilter('Ponto', idFk)
            var typePoint = props.match.params.tipo
            var vetorType = props.match.params.vetor

            const requiredPerms = [
                'acao.ponto.urbano.visita.adicionar',
                'acao.ponto.urbano.visita.editar',
                'acao.ponto.urbano.visita.excluir',

                'acao.ponto.rural.visita.adicionar',
                'acao.ponto.rural.visita.editar',
                'acao.ponto.rural.visita.excluir',

                'acao.ponto.cemiterio.visita.adicionar',
                'acao.ponto.cemiterio.visita.editar',
                'acao.ponto.cemiterio.visita.excluir',

                'acao.ponto.diverso.visita.adicionar',
                'acao.ponto.diverso.visita.editar',
                'acao.ponto.diverso.visita.excluir',

                'acao.vetor.ponto.visita.adicionar',
                'acao.vetor.ponto.visita.editar',
                'acao.vetor.ponto.visita.excluir',

            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPerms} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }

                    if (permissions["acao.ponto.urbano.visita.adicionar"] == false && typePoint === 'U' ||
                        permissions["acao.ponto.rural.visita.adicionar"] == false && typePoint === 'R' ||
                        permissions["acao.ponto.cemiterio.visita.adicionar"] == false && typePoint === 'C' ||
                        permissions["acao.ponto.diverso.visita.adicionar"] == false && typePoint === 'D' ||
                        permissions["acao.vetor.ponto.visita.adicionar"] == false && (typePoint === null || typePoint === "null")) {
                        actionPerms.add = false
                    }
                    if (permissions["acao.ponto.urbano.visita.editar"] == false && typePoint === 'U' ||
                        permissions["acao.ponto.rural.visita.editar"] == false && typePoint === 'R' ||
                        permissions["acao.ponto.cemiterio.visita.editar"] == false && typePoint === 'C' ||
                        permissions["acao.ponto.diverso.visita.editar"] == false && typePoint === 'D' ||
                        permissions["acao.vetor.ponto.visita.editar"] == false && (typePoint === null || typePoint === "null")) {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.ponto.urbano.visita.excluir"] == false && typePoint === 'U' ||
                        permissions["acao.ponto.rural.visita.excluir"] == false && typePoint === 'R' ||
                        permissions["acao.ponto.cemiterio.visita.excluir"] == false && typePoint === 'C' ||
                        permissions["acao.ponto.diverso.visita.excluir"] == false && typePoint === 'D' ||
                        permissions["acao.vetor.ponto.visita.excluir"] == false && (typePoint === null || typePoint === "null")) {
                        actionPerms.del = false
                    }

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Visita"}
                        filter={[filter]}
                        options={arrayOptions}
                        actionPerms={actionPerms}
                    />)
                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormVisit(): JSX.Element {
        var viewModel = new VisitViewModel()
        return (<ProtectedRoute path="/:base/ponto/:idPoint/visita/cad/:id" exact={true} component={(props: any) => {
            var idPoint = props.match.params.idPoint
            var idPk = props.match.params.id
            return (<VisitViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idPoint={idPoint} />)
        }} />)
    }

    private routeTableVisitShape(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepvisita")
        return (<ProtectedRoute path="/:base/shape/:id/tipo/:tipo/tipo-vetor/:vetor/visita/" exact={true} component={(props: any) => {
            var idFk = props.match.params.id
            var filter = new TableGenericFilter('Shape', idFk)
            var typePoint = props.match.params.tipo
            var vetorType = props.match.params.vetor


            const requiredPerms = [
                'acao.vetor.ponto.visita.adicionar',
                'acao.vetor.ponto.visita.editar',
                'acao.vetor.ponto.visita.excluir',

                'acao.vetor.linha.visita.adicionar',
                'acao.vetor.linha.visita.editar',
                'acao.vetor.linha.visita.excluir',

                'acao.vetor.poligono.visita.adicionar',
                'acao.vetor.poligono.visita.editar',
                'acao.vetor.poligono.visita.excluir',
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPerms} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }

                    if (permissions["acao.vetor.ponto.visita.adicionar"] == false && (typePoint === null || typePoint === "null") && vetorType == "Point" ||
                        permissions["acao.vetor.linha.visita.adicionar"] == false && (vetorType == 'MultiLineString' || vetorType == "LineString" || vetorType == "Line") ||
                        permissions["acao.vetor.poligono.visita.adicionar"] == false && (vetorType == 'Polygon' || vetorType == "MultiPolygon")) {
                        actionPerms.add = false
                    }
                    if (permissions["acao.vetor.ponto.visita.editar"] == false && (typePoint === null || typePoint === "null") && vetorType == "Point" ||
                        permissions["acao.vetor.linha.visita.editar"] == false && (vetorType == 'MultiLineString' || vetorType == "LineString" || vetorType == "Line") ||
                        permissions["acao.vetor.poligono.visita.editar"] == false && (vetorType == 'Polygon' || vetorType == "MultiPolygon")) {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.vetor.ponto.visita.excluir"] == false && (typePoint === null || typePoint === "null") && vetorType == "Point" ||
                        permissions["acao.vetor.linha.visita.excluir"] == false && (vetorType == 'MultiLineString' || vetorType == "LineString" || vetorType == "Line") ||
                        permissions["acao.vetor.poligono.visita.excluir"] == false && (vetorType == 'Polygon' || vetorType == "MultiPolygon")) {
                        actionPerms.del = false
                    }

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Visita"}
                        filter={[filter]}
                        options={arrayOptions}
                        actionPerms={actionPerms}
                    />)

                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormVisitShape(): JSX.Element {
        var viewModel = new VisitViewModel()
        return (<ProtectedRoute path="/:base/shape/:idShape/visita/cad/:id" exact={true} component={(props: any) => {
            var idShape = props.match.params.idShape
            var idPk = props.match.params.id

            return (<VisitViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idShape={idShape} />)
        }} />)
    }

    private routeTableVisitAdminProcess(): JSX.Element {

        var viewModel = new TableGenericViewModel("gepvisita")
        return (<ProtectedRoute path="/:base/processo-administrativo/:id/visita/" exact={true} component={(props: any) => {
            var idFk = props.match.params.id
            var filter = new TableGenericFilter('ProcessoAdministrativo', idFk)
            const requiredPermissions = [
                'acao.visita.proc_adm.adicionar',
                'acao.visita.proc_adm.editar',
                'acao.visita.proc_adm.excluir'
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPermissions} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }

                    if (permissions["acao.visita.proc_adm.adicionar"] == false) {
                        actionPerms.add = false
                    }
                    if (permissions["acao.visita.proc_adm.editar"] == false) {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.visita.proc_adm.excluir"] == false) {
                        actionPerms.del = false
                    }

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })
                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Visita"}
                        filter={[filter]}
                        options={arrayOptions}
                        actionPerms={actionPerms}
                    />)

                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormVisitAdminProcess(): JSX.Element {
        var viewModel = new VisitViewModel()
        return (<ProtectedRoute path="/:base/processo-administrativo/:idAdminProcess/visita/cad/:id" exact={true} component={(props: any) => {
            var idAdminProcess = props.match.params.idAdminProcess
            var idPk = props.match.params.id

            return (<VisitViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idAdminProcess={idAdminProcess} />)

        }} />)
    }

    private routeTableVisitProperty(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepvisita")
        return (<ProtectedRoute path="/:base/propriedade/tipo/:tipo/:id/visita/" exact={true} component={(props: any) => {
            var idFk = props.match.params.id
            var filter = new TableGenericFilter('Propriedade', idFk)
            var pointType = props.match.params.tipo

            const requiredPermissions = [
                'acao.hist_prop.urbano.visita.adicionar',
                'acao.hist_prop.urbano.visita.editar',
                'acao.hist_prop.urbano.visita.excluir',

                'acao.hist_prop.rural.visita.adicionar',
                'acao.hist_prop.rural.visita.editar',
                'acao.hist_prop.rural.visita.excluir',

                'acao.hist_prop.cemiterio.visita.adicionar',
                'acao.hist_prop.cemiterio.visita.editar',
                'acao.hist_prop.cemiterio.visita.excluir',

                'acao.hist_prop.diverso.visita.adicionar',
                'acao.hist_prop.diverso.visita.editar',
                'acao.hist_prop.diverso.visita.excluir'
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPermissions} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }

                    if (permissions["acao.hist_prop.urbano.visita.adicionar"] == false && pointType === 'U' ||
                        permissions["acao.hist_prop.rural.visita.adicionar"] == false && pointType === 'R' ||
                        permissions["acao.hist_prop.cemiterio.visita.adicionar"] == false && pointType === 'C' ||
                        permissions["acao.hist_prop.diverso.visita.adicionar"] == false && pointType === 'D') {
                        actionPerms.add = false
                    }
                    if (permissions["acao.hist_prop.urbano.visita.editar"] == false && pointType === 'U' ||
                        permissions["acao.hist_prop.rural.visita.editar"] == false && pointType === 'R' ||
                        permissions["acao.hist_prop.cemiterio.visita.editar"] == false && pointType === 'C' ||
                        permissions["acao.hist_prop.diverso.visita.editar"] == false && pointType === 'D') {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.hist_prop.urbano.visita.excluir"] == false && pointType === 'U' ||
                        permissions["acao.hist_prop.rural.visita.excluir"] == false && pointType === 'R' ||
                        permissions["acao.hist_prop.cemiterio.visita.excluir"] == false && pointType === 'C' ||
                        permissions["acao.hist_prop.diverso.visita.excluir"] == false && pointType === 'D') {
                        actionPerms.del = false
                    }
                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })

                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Visita"}
                        filter={[filter]}
                        options={arrayOptions}
                        actionPerms={actionPerms}
                    />)

                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormVisitProperty(): JSX.Element {
        var viewModel = new VisitViewModel()
        return (<ProtectedRoute path="/:base/propriedade/:idProperty/visita/cad/:id" exact={true} component={(props: any) => {
            var idProperty = props.match.params.idProperty
            var idPk = props.match.params.id
            return (<VisitViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idProperty={idProperty} />)

        }} />)
    }

    private routeTableVisitPropertyBuilding(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepvisita")
        return (<ProtectedRoute path="/:base/edificacao/tipo/:tipo/:id/visita/" exact={true} component={(props: any) => {
            var idFk = props.match.params.id
            var filter = new TableGenericFilter('Edificação', idFk)
            var pointType = props.match.params.tipo

            const requiredPermissions = [
                'acao.edif.urbano.visita.adicionar',
                'acao.edif.urbano.visita.editar',
                'acao.edif.urbano.visita.excluir',

                'acao.edif.rural.visita.adicionar',
                'acao.edif.rural.visita.editar',
                'acao.edif.rural.visita.excluir',

                'acao.edif.cemiterio.visita.adicionar',
                'acao.edif.cemiterio.visita.editar',
                'acao.edif.cemiterio.visita.excluir'
            ]

            return (
                <PermissionWrapper requiredPermissions={requiredPermissions} delegate={this}>{(permissions, delegate) => {
                    var arrayOptions = new Array<NavOptions>()

                    let actionPerms = {
                        add: true,
                        edit: true,
                        del: true,
                    }

                    if (permissions["acao.edif.urbano.visita.adicionar"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.visita.adicionar"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.visita.adicionar"] == false && pointType === 'C') {
                        actionPerms.add = false
                    }
                    if (permissions["acao.edif.urbano.visita.editar"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.visita.editar"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.visita.editar"] == false && pointType === 'C') {
                        actionPerms.edit = false
                    }
                    if (permissions["acao.edif.urbano.visita.excluir"] == false && pointType === 'U' ||
                        permissions["acao.edif.rural.visita.excluir"] == false && pointType === 'R' ||
                        permissions["acao.edif.cemiterio.visita.excluir"] == false && pointType === 'C') {
                        actionPerms.del = false
                    }

                    arrayOptions.push({
                        title: "Arquivos Digitais (Documentos)",
                        action: (navigation: any, item: any, component: React.Component) => delegate.routerDocuments(navigation, item),
                        isSelection: true
                    })
                    return (<TableGenericViewController
                        navigation={props}
                        viewModel={viewModel}
                        delegate={delegate}
                        title={"Visita"}
                        filter={[filter]}
                        options={arrayOptions}
                        actionPerms={actionPerms}
                    />)

                }}
                </PermissionWrapper>
            )
        }} />)
    }

    private routeFormVisitPropertyBuilding(): JSX.Element {
        var viewModel = new VisitViewModel()
        return (<ProtectedRoute path="/:base/edificacao/:idPropertyBuilding/visita/cad/:id" exact={true} component={(props: any) => {
            var idPropertyBuilding = props.match.params.idPropertyBuilding
            var idPk = props.match.params.id
            return (<VisitViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
                idPropertyBuilding={idPropertyBuilding} />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        var filter = viewModel.getFilter()
        if (viewModel.getTable() == "gepvisita" && filter) {
            var database = localStorage.getItem('database')
            var typeFk = filter[0].getColumn() == "Ponto" ? 'ponto' : 'shape'
            if (filter[0].getColumn() == "ProcessoAdministrativo") {
                typeFk = "processo-administrativo"
            } else if (filter[0].getColumn() == "Propriedade") {
                typeFk = "propriedade"
            } else if (filter[0].getColumn() == "Edificação") {
                typeFk = "edificacao"
            }

            navigation.history.push(`/${database}/${typeFk}/${filter[0].getValue()}/visita/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {

        var filter = viewModel.getFilter()
        if (viewModel.getTable() == "gepvisita" && filter) {
            var database = localStorage.getItem('database')
            var typeFk = filter[0].getColumn() == "Ponto" ? 'ponto' : 'shape'
            if (filter[0].getColumn() == "ProcessoAdministrativo") {
                typeFk = "processo-administrativo"
            } else if (filter[0].getColumn() == "Propriedade") {
                typeFk = "propriedade"
            } else if (filter[0].getColumn() == "Edificação") {
                typeFk = "edificacao"
            }

            navigation.history.push(`/${database}/${typeFk}/${filter[0].getValue()}/visita/cad/${idSelection}`);
            return;
        }
    }

    private routerDocuments(navigation: any, item: any) {
        var database = localStorage.getItem('database')
        navigation.history.push(`/${database}/visita/${item}/arquivos`);
    }

}